import { render, staticRenderFns } from "./userData.vue?vue&type=template&id=a33ffe1e&scoped=true"
import script from "./userData.vue?vue&type=script&lang=js"
export * from "./userData.vue?vue&type=script&lang=js"
import style0 from "./userData.vue?vue&type=style&index=0&id=a33ffe1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33ffe1e",
  null
  
)

export default component.exports